import { render, staticRenderFns } from "./Academys.vue?vue&type=template&id=f40b997c"
import script from "./Academys.vue?vue&type=script&lang=js"
export * from "./Academys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports